import {api, API_BASE_URL} from "@/api/axios";
import axios from "axios";

const apiNoToken = axios.create({
    baseURL: API_BASE_URL,
});

export function getPropertiesApi(params) {
    return apiNoToken.get(`/properties`,{params: {...params, affiliateBrand: 'JIM_PARTNERS'}})
}

export function getGeoApi(params) {
    return api.get(`/properties/geo`,{params: {...params, affiliateBrand: 'JIM_PARTNERS'}})
}

export function getTrafficTypeApi(params) {
    return api.get(`/properties/affiliate_traffic_type`, {params: {...params, affiliateBrand: 'JIM_PARTNERS'}})
}

export function getPropertiesByCodeApi(code, params= {}) {
    return api.get(`/properties/${code}`, {params: {...params, affiliateBrand: 'JIM_PARTNERS'}})
}

export function getBrandsApi() {
    return api.get(`/casino-brands`)
}

export function getLanguagesApi() {
    return apiNoToken.get(`/affiliate-brands/JIM_PARTNERS/languages`)
}

export function unsubscriptionMailingApi(params) {
    return apiNoToken.post(`subscriptions/disable-mailing`, {}, {params})
}
